<template>
  <span @click.stop="/* Stop propagation is required if TextRef are nested */">
    <span ref="wrapped" tabindex="0" class="text-with-ref" :class="type">
      <text-with-refs :text="text"/>
    </span><b-popover :target="() => $refs.wrapped" placement="auto" triggers="click blur"><note :id="id"/></b-popover>
  </span>
</template>
<script>
  import uniq from 'lodash/uniq'
  import Note from './Note'

  export default {
    components: {
      Note,
      TextWithRefs: () => import('./TextWithRefs')
    },
    props: {
      id: {type: Array, required: true},
      text: {type: Array, required: true}
    },
    computed: {
      notes() {
        return this.id.map(id => this.$store.state.notes[id])
      },
      type() {
        const classes = uniq(this.notes.map(note => note.class))
        const variants = this.notes.filter(note => note.class === 'Variants')
        if (variants.every(note => note.type === 'AllOmitted')) {
          classes.push('VariantsAllOmitted')
        } else if (variants.some(note => note.type === 'AllOmitted' || note.type === 'SomeOmitted')) {
          classes.push('VariantsSomeOmitted')
        }
        return classes.join(' ')
      }
    }
  }
</script>
<style lang="scss" scoped>
  @import "app/javascript/scss/variables";

  .text-with-ref {
    cursor: pointer;

    &.Note {
      @include note-style;
    }

    &.Variants {
      @include variant-style;

      &.VariantsSomeOmitted {
        @include omitted-style;
      }

      &.VariantsAllOmitted {
        @include omitted-style;
        background-color: initial;
      }
    }
  }
</style>
